<template>
  <div class="overall-status">
    <div class="overall-status__main">
      <div class="overall-label">Overall Status</div>
      <div
        class="overall-value"
        :class="'overall-value--' + overall.className"
      >{{ overall.short }}</div>
      <div class="overall-sub">{{ subline }}</div>
    </div>
    <div v-if="overall.badge" class="overall-badge">
      <span class="overall-badge__tag">{{ overall.badge.tag }}</span>
      <span class="overall-badge__sub">{{ overall.badge.sub }}</span>
    </div>
  </div>
</template>

<script>
/**
 * Right-panel overall status block.
 *
 * Prop-driven — consumes VERIFICATION/GET_OVERALL_DISPLAY. Large headline
 * value on the left, optional NCR-style badge on the right, subline with
 * progress + failing count below.
 *
 * Wireframe reference: AVA Verification Wireframe.html lines 425-438, 757-767.
 */
export default {
  name: 'OverallStatus',
  props: {
    overall: {
      type: Object,
      required: true,
      // { short, className, progress, failing, badge }
    },
  },
  computed: {
    subline() {
      if (this.overall.failing) {
        return `${this.overall.progress} · ${this.overall.failing}`;
      }
      return this.overall.progress;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/verification-tokens';

.overall-status {
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: center;
  border-bottom: 1px solid $vf-line-soft;
}

.overall-label {
  font-family: $vf-font-mono;
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: $vf-ink-3;
  line-height: 1.4;
}

.overall-value {
  font-family: $vf-font-heading;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 1.1;
  margin-top: 2px;

  &--pass { color: $vf-harvest; }
  &--fail { color: $vf-error; }
  &--pending { color: $vf-ink-2; }
}

.overall-sub {
  font-size: 11px;
  color: $vf-ink-2;
  margin-top: 2px;
}

.overall-badge {
  padding: 8px 12px;
  border-radius: $vf-r-sm;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  background: rgba(183, 28, 28, 0.08);
  border: 1px solid rgba(183, 28, 28, 0.3);
  color: $vf-error;
  min-width: 64px;
  text-align: center;

  &__tag {
    font-family: $vf-font-heading;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    line-height: 1;
  }

  &__sub {
    font-size: 9px;
    font-family: $vf-font-mono;
    color: $vf-error;
    letter-spacing: 0.12em;
    opacity: 0.8;
    line-height: 1;
  }
}
</style>
